/**
 * Make sure this is loaded after the main script.
 *
 * Changelog:
 * 1. 05.11.2018 / enzo@exportarts.io / Added ZIPs
 *
 */

/**
 * Get the list of allowed ZIPs.
 *
 * @return string[]
 */
window.Exportarts.Zip.allowedZips = function() {
  return [
    '60306',
    '60308',
    '60310',
    '60311',
    '60312',
    '60313',
    '60314',
    '60316',
    '60318',
    '60320',
    '60322',
    '60323',
    '60325',
    '60326',
    '60327',
    '60329',
    '60345',
    '60385',
    '60386',
    '60388',
    '60389',
    '60431',
    '60433',
    '60437',
    '60438',
    '60439',
    '60486',
    '60487',
    '60488',
    '60489',
    '60528',
    '60529',
    '60549',
    '60594',
    '60596',
    '60598',
    '60599',
    '61348',
    '61350',
    '61352',
    '61440',
    '63065',
    '63067',
    '63069',
    '63071',
    '63073',
    '63075',
    '63263',
    '65929',
    '65931',
    '65933',
    '65934',
    '65936',
    '65760'
  ];
}